import { Collaborator } from './collaborator.model';
import { GeoDsMeta } from './meta-data.model';

export class MeasureTask extends GeoDsMeta {
  ParentId: string;
  ParentObjectType: string;
  IdRefDepartment: string;
  IdRefPersonResubmissionFor: string;
  DegreeOfImplementation: number;
  Efficiency: number;
  IdRefResponsible: string;
  IdRefxmtMeasureTask: string;
  TotalTimeRequired: number;
  TotalTimeExecuted: number;
  TargetDate: Date;
  StartDate: Date;
  StartTime: Date;
  Subject: string;
  EndDate: Date;
  EndTime: Date;
  TargetMaturityLevel: string;
  FinishedOn?: Date | string;
  Task: string;
  Type: number;
  Comment: string;
  Description: string;
  Collaborators?: Collaborator[];
  Label?: string;
  Responsible?: string;
  Notes?: string;
  IsFavorite?: number;
  BoxDetailId?: string;
  Status?: number;
  Priority?: number;
  Duration?: number;
  IntervalKind?: number;
  constructor(data) {
    super();
    Object.assign(this, data);
  }
}
